const layerTypes = {
    layer: 'Layer',
    group: 'Group'
}

export default layerTypes